import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 7C5309A2-5DA1-4393-8846-0CF5CB43BF88
 * name clipboard-minus
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-minus.svg
 * tags
 */
export const ClipboardMinusIcon = createSvgIcon(<><path d="M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M16 14H8V12H16V14Z" /></>, 'ClipboardMinusIcon');
export default ClipboardMinusIcon